import { render, staticRenderFns } from "./CcTour.vue?vue&type=template&id=18676a3f&scoped=true"
import script from "./CcTour.vue?vue&type=script&setup=true&lang=js"
export * from "./CcTour.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CcTour.vue?vue&type=style&index=0&id=18676a3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18676a3f",
  null
  
)

export default component.exports